import { useRef } from 'react';
import { cn } from '@/lib/utils';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { DesktopSidebarProps } from './types';

export function DesktopSidebar({
  listComponent,
  isScrollable = true,
}: DesktopSidebarProps) {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const desktopSidebarRef = useRef<HTMLDivElement>(null);

  // Don't render on mobile for clean map-only experience
  if (isMobile) return null;

  return (
    <div
      ref={desktopSidebarRef}
      className={cn(
        "w-full md:w-[400px] lg:w-[450px] md:border-r custom-scrollbar-dark [scrollbar-gutter:stable]",
        isScrollable ? "overflow-y-auto" : "overflow-y-hidden",
        "hidden md:block"
      )}
    >
      {/* Business Cards or Custom List Component */}
      {listComponent}
    </div>
  );
}
